import { getCookie, setCookie } from '@remarkablenet/rcm-utils/cookies';
import getClosest from '../get-closest/get-closest';
import { activate, deactivate } from '../css-transition-helper/css-transition-helper';

const GDPR_ACCEPT_SELECTOR = '.js-accept-gdpr';

export const init = cookieConsentContainer => hasUserConsentedToCookies(cookieConsentContainer);

const getCookieAttributeName = element => element.getAttribute('data-cookie-string') as string;

const hasUserConsentedToCookies = cookieConsentContainer => {

    if (!cookieConsentContainer) return;

    const cookieName = getCookieAttributeName(cookieConsentContainer);

    if (!getCookie({ name: cookieName })) {
        import('../../../css/bem/_cookie-consent.scss')
            .then(() => {
                showConsentContainer(cookieConsentContainer);
                activate(cookieConsentContainer)
                    .then(addCookieConsentBtnEventListeners);
            }); 

        return;
    }

    destroyCookieContainer(cookieConsentContainer);
};

const addCookieConsentBtnEventListeners = cookieConsentContainer => {
    const cookieConsentBtn = cookieConsentContainer.querySelector(GDPR_ACCEPT_SELECTOR);
    if (!cookieConsentBtn) return;

    cookieConsentBtn.addEventListener('click', setCookieToConsented);
};

const setCookieToConsented = event => {
    const cookieContainer = getClosest(event.target, '#cookieConsent');
    const cookieString = getCookieAttributeName(cookieContainer);

    setCookie({ name: cookieString, value: '1', days: 365 });
    destroyCookieContainer(cookieContainer);
}; 

const destroyCookieContainer = cookieConsentContainer => {
    deactivate(cookieConsentContainer)
        .then(() => {
            cookieConsentContainer.parentNode.removeChild(cookieConsentContainer);
        });
};

const showConsentContainer = cookieConsentContainer => {
    if (!cookieConsentContainer) return;
    cookieConsentContainer.classList.remove('d-none');
};